import { useFeatureFlagEnabled } from 'posthog-js/react';

export const FEATURE_FLAGS = {
  IS_BEACON_STAFF: 'is-beacon-staff',
  Q3_ROADMAP_SURVEY: 'q3-roadmap-survey',
  CANDIDATE_EVIDENCE: 'candidate-evidence',
  CANDIDATE_GREEN_FLAGS: 'candidate-green-flags',
  REALTIME_EVENTS: 'realtime-events',
} as const;

type FlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export function useFeatureFlag(flag: FlagKey): boolean {
  return useFeatureFlagEnabled(flag) ?? false;
}
